/**
 * Single global lock for “modal open” — disables page scroll while overlays are visible.
 * Uses position:fixed on body (works reliably on iOS); restores scroll position on unlock.
 */

let locked = false;
let savedScrollY = 0;
let lockMode = "fixed";

function preferOverflowOnlyScrollLock() {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(max-width: 767px)").matches;
}

export function setGlobalBodyScrollLocked(shouldLock) {
  if (shouldLock === locked) return;
  locked = shouldLock;

  const body = document.body;
  const html = document.documentElement;

  if (shouldLock) {
    savedScrollY = window.scrollY || html.scrollTop || body.scrollTop || 0;
    body.dataset.prevOverflow = body.style.overflow || "";
    html.dataset.prevOverflow = html.style.overflow || "";

    if (preferOverflowOnlyScrollLock()) {
      lockMode = "overflow";
      body.style.overflow = "hidden";
      html.style.overflow = "hidden";
    } else {
      lockMode = "fixed";
      body.style.overflow = "hidden";
      html.style.overflow = "hidden";
      body.style.position = "fixed";
      body.style.top = `-${savedScrollY}px`;
      body.style.left = "0";
      body.style.right = "0";
      body.style.width = "100%";
    }
  } else {
    body.style.overflow = body.dataset.prevOverflow || "";
    html.style.overflow = html.dataset.prevOverflow || "";
    delete body.dataset.prevOverflow;
    delete html.dataset.prevOverflow;

    if (lockMode === "fixed") {
      body.style.position = "";
      body.style.top = "";
      body.style.left = "";
      body.style.right = "";
      body.style.width = "";
      window.scrollTo(0, savedScrollY);
    }
    lockMode = "fixed";
  }
}
